module.exports = __webpack_public_path__ + "static/img/声光电系统施工.cfcb8dfb.png";